<script setup lang="ts">
const { data: post } = await useAsyncData(`pages-404`, async () => {
  return await queryCollection('content').path('/dynamic/404').first()
})

if (!post.value) {
  throw createError({ statusCode: 404, statusMessage: 'Post not found', fatal: true })
}

const title = post.value.title
const description = post.value.description

useSeoMeta({
  title,
  ogTitle: title,
  description,
  ogDescription: description,

})
</script>

<template>
  <UApp>
    <NavHeader />

    <UMain>
      <UContainer v-if="post">
        <UPageHeader
          :title="post.title"
          :description="post.description"
        />
        <UPage>
          <UPageBody class="prose">
            <ContentRenderer
              v-if="post && post.body"
              :value="post"
            />
          </UPageBody>

          <template #right>
            <div class="mt-12 relative">
              <SidebarCompareAgents class="static" />
            </div>
          </template>
        </UPage>
      </UContainer>
    </UMain>

    <NavFooter />
  </UApp>
</template>
